/* unplugin-vue-components disabled */import { render } from "./SelectBrandDialog.vue?vue&type=template&id=632ba80e"
import script from "./SelectBrandDialog.vue?vue&type=script&lang=js"
export * from "./SelectBrandDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__